define('mustache-language/mustache-language',['require','exports','module','./translator'],function(require,exports,module){

    var translatorFactory = require( "./translator" );

    function lambda(lang){
        var lamb, translator;
        
        if(lang) {
            translator = translatorFactory(lang);
            lamb = function(key, values){
                translator.key=key;
                return translator.translate;
            };
        } else {
            lamb = function(key, values){
                return key;
            };
        }

        // lamb.upperCase  = function(){ console.log("eh");return translator.translateUpperCase};
        // lamb.lowerCase  = translator.translateLowerCase;
        // lamb.capitalize = translator.translateCapitalize;

        return lamb;
    }
    /**
     * Lambda function generator for translating portions of mustache templates
     * @param  {string} lang Local language id
     * @return {function}    Lambda function with translator method for selected language.
     */
    return function(lang){ 
        return lambda(lang)
    }

});
